import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const PromotionDevelopPageStyle = {
  self: css`
    /*  */
  `,
  wrapper: css`
    min-height: var(--min-height-content-layout);
    padding: 20px;
    ${media.sm} {
      padding: 12px 0px;
    }
  `,
  head: css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 26px;
  `,

  listPromos: css`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    ${media.sm} {
      grid-template-columns: 1fr;
      gap: 6px;
    }
  `,

  empty: css`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 500px;
  `,

  categoryWrapper: css`
    margin-bottom: 20px;
  `,

  banner: css`
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-bottom: solid 20px ${theme.colors.orange[200]};
    }
  `,
};
